import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { configUrl } from "../constants/Config";
import { ApplicationState } from "../redux/ApplicationState";
import {
  MfaPreferenceActionDispatchTypes,
  ResendRegistrationActionDispatchTypes,
  ResetPasswordActionDispatchTypes,
  UserDetailsActionDispatchTypes,
  UserStatusActionDispatchTypes,
} from "../constants/MyAccount";
import { GetMfaMaster } from "../services/Master";
import {
  MasterMfaPreferenceDispatchTypes,
  ResendRegistrationDispatchTypes,
  ResetPasswordDispatchTypes,
  UserStatusDispatchTypes,
} from "../models/dispatchTypes/MyAccount";
import {
  GetActivateDeactivateUser,
  GetResendRegistration,
  GetResetPassword,
  PutUserDetails,
} from "../services/MyAccount";
import toastType from "../utils/SnackbarProvider";
import { MyAccountModel } from "../models/MyAccount";
import { serverSideErrorMsg } from "../utils";
import { ActiveDeActivePayload } from "../models/User";
import { MessageType, ResponseMessages } from "../constants/ResponseMessage";

export const getMfaPreference: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    MasterMfaPreferenceDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: MfaPreferenceActionDispatchTypes.MASTER_MFA_PREFERENCE_INVOKE,
    });
    const response = await GetMfaMaster(configUrl);
    dispatch({
      response: response.data,
      type: MfaPreferenceActionDispatchTypes.MASTER_MFA_PREFERENCE_SUCCESS,
    });
  };
};

export const updateUserDetails: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    MasterMfaPreferenceDispatchTypes
  >
> = (payload: MyAccountModel) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UserDetailsActionDispatchTypes.UPDATE_USER_DETAILS_INVOKE,
    });
    const response = await PutUserDetails(configUrl, payload);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          toastType.error(
            ResponseMessages(MessageType.USER_DETAILS_UPDATE_FAILURE)
          );
          for (const key in response.data) {
            if (response.data[key]) {
              toastType.error(response.data[key][0]);
            }
          }
          dispatch({
            error: response.data,
            type: UserDetailsActionDispatchTypes.UPDATE_USER_DETAILS_ERROR,
          });
          break;
        case 200:
        case 201:
          toastType.success(ResponseMessages(MessageType.USER_DETAILS_UPDATED))
          dispatch({
            response: response.data,
            type: UserDetailsActionDispatchTypes.UPDATE_USER_DETAILS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getResetPassword: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ResetPasswordDispatchTypes
  >
> = (email: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ResetPasswordActionDispatchTypes.RESET_PASSWORD_INVOKE,
    });
    const response = await GetResetPassword(configUrl, email);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          response.data.errors ? serverSideErrorMsg(response.data.errors) :  toastType.error(
            ResponseMessages(MessageType.RESET_PASS_LINK_NOT_SHARED)
          );
          dispatch({
            error: response,
            type: ResetPasswordActionDispatchTypes.RESET_PASSWORD_ERROR,
          });

          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: ResetPasswordActionDispatchTypes.RESET_PASSWORD_SUCCESS,
          });
          toastType.success(
            ResponseMessages(MessageType.RESET_PASS_LINK_SHARED)
          );
          break;
        default:
          break;
      }
    }
  };
};

export const getResendRegistration: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ResendRegistrationDispatchTypes
  >
> = (email: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ResendRegistrationActionDispatchTypes.RESEND_REGISTRATION_INVOKE,
    });
    const response = await GetResendRegistration(configUrl, email);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          response.data.errors ? serverSideErrorMsg(response.data.errors) :  toastType.error(
            ResponseMessages(MessageType.RESENT_REGISTRATION_LINK_FAILURE)
          );
          dispatch({
            error: response,
            type: ResendRegistrationActionDispatchTypes.RESEND_REGISTRATION_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: ResendRegistrationActionDispatchTypes.RESEND_REGISTRATION_SUCCESS,
          });
          toastType.success(
            ResponseMessages(MessageType.RESENT_REGISTRATION_LINK_SUCCESS
            )
          );
          break;
        default:
          break;
      }
    }
  };
};

export const getActivateDeactivateUser: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    UserStatusDispatchTypes
  >
> = (payload: ActiveDeActivePayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UserStatusActionDispatchTypes.USER_STATUS_INVOKE,
    });
    const response = await GetActivateDeactivateUser(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          response.data.errors ? serverSideErrorMsg(response.data.errors) :  toastType.error(ResponseMessages(MessageType.USER_STATUS_NOT_UPDATE));
          dispatch({
            error: response,
            type: UserStatusActionDispatchTypes.USER_STATUS_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: UserStatusActionDispatchTypes.USER_STATUS_SUCCESS,
          });
          toastType.success(response.data);
          break;
        default:
          break;
      }
    }
  };
};
